import { render } from "./cloudflare-dns-records.vue?vue&type=template&id=c51ad4c0&scoped=true"
import script from "./cloudflare-dns-records.vue?vue&type=script&lang=js"
export * from "./cloudflare-dns-records.vue?vue&type=script&lang=js"

import "./cloudflare-dns-records.vue?vue&type=style&index=0&id=c51ad4c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c51ad4c0"]])

export default __exports__